import React from 'react'
import { TimesheetApprovalDetails as TimesheetApprovalContent } from '../components/Timesheet/TimesheetApprovalDetails';
import { useParams } from 'react-router-dom';
export const TimesheetApprovalDetails = () => {
    const { timesheetId } = useParams();
    return <TimesheetApprovalContent timesheetId={timesheetId} />
}
